import { deduplicateArray, nullishFilter, formatCamelCase } from '@caresend/utils';
import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$2 from './WaypointProcedureCard/WaypointProcedureCard.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';
import __vue_component__$1 from '../../../../../ui/Skeleton.vue.js';
import __vue_component__$3 from '../../../../../ui/Tag/Tag.vue.js';
import { getStore } from '../../../../../../store/helpers/initStore.js';

var script = defineComponent({
    name: 'ItineraryWaypointActionsList',
    components: {
        BasicCard: __vue_component__,
        Skeleton: __vue_component__$1,
        WaypointProcedureCard: __vue_component__$2,
        Tag: __vue_component__$3,
    },
    props: {
        isLoading: Boolean,
        waypointActions: {
            type: Array,
            required: true,
        },
    },
    setup(props) {
        const store = getStore();
        const portalStore = usePortalStore();
        const procedureIDs = computed(() => deduplicateArray(props.waypointActions
            .map((waypointAction) => { var _a; return Object.keys((_a = waypointAction.procedures) !== null && _a !== void 0 ? _a : {}); }).flat()));
        const getPatientNameFromWaypointAction = (waypointAction) => {
            var _a, _b, _c;
            const patientID = (_a = portalStore.waypointActions.get(waypointAction.id)) === null || _a === void 0 ? void 0 : _a.computed.singlePatientID;
            if (!patientID)
                return formatCamelCase((_b = waypointAction.type) !== null && _b !== void 0 ? _b : '');
            const patient = store.getters['users/getUserByID'](patientID);
            if (!(patient === null || patient === void 0 ? void 0 : patient.id))
                return null;
            return (_c = store.getters['users/getUserFullName'](patient.id)) !== null && _c !== void 0 ? _c : null;
        };
        const patientNames = computed(() => props.waypointActions.map((wpa) => getPatientNameFromWaypointAction(wpa)).filter(nullishFilter).join(', '));
        const patientNamesClass = computed(() => portalStore.state.value.patientNamesRedacted
            ? 'ItineraryWaypointActionsList__patient-names-redacted' : '');
        const isCollectionLoading = computed(() => props.waypointActions.map((wpa) => { var _a; return (_a = portalStore.waypointActions.get(wpa.id)) === null || _a === void 0 ? void 0 : _a.computed.singlePatientID; }).some((id) => id && store.getters['app/getIsLoading'](id)));
        return {
            patientNames,
            procedureIDs,
            isCollectionLoading,
            patientNamesClass,
        };
    },
});

export { script as default };
